export default __webpack_public_path__ + "static/media/adst_banner.9be6b3cb.png";